import React, {useState, useEffect} from 'react';
import { 
  ResponsiveContainer,
  Legend,
  PieChart, 
  Pie, 
  Cell,
   } from 'recharts';
import HelpOutlineIcon from '@mui/icons-material/HelpOutline';
import InfoIcon from '@mui/icons-material/Info';
import {
  IconButton,
  Tooltip,
  Grid,
  CircularProgress
} from '@mui/material';
import {Tooltip as TooltipRecharts} from 'recharts';

import Title from '../../../../components/Title';
import socket from '../../../../services/socket';

import { indigo, blue } from '@mui/material/colors';

export default function ProductReason(props) {
  const [ProductReason,setProductReason] = useState([]);
  const store_id = props.store_id;
  const [isLoading,setIsLoading] = useState(true);
  useEffect( () => {   
    function askProductReason(){
      socket.emit('/vezo/StoreInfo/askProductReason',{ 
                      'store_id': store_id,}
                    ,(data)=>{console.log(data);})
    }

    async function loadProductReason(){
      askProductReason()
      socket.on('/vezo/StoreInfo/updateProductReason/'+store_id,()=>{
        // When the server sends a updatePaperInfo, it asks for newer intel
        askProductReason();
      })
      socket.on('/vezo/StoreInfo/ProductReason/'+store_id,(data)=>{
        let DatawithColor = []
        data.forEach((store,index)=>{
          var dataTemp
          if(index%2){
            dataTemp = Object.assign({},store,{"fill":indigo[((index+1)*100)]})
          }
          else{
            dataTemp = Object.assign({},store,{"fill":blue[((index+1)*100)]})
          }
          DatawithColor.push(dataTemp)
        })
        setProductReason(DatawithColor)
        setIsLoading(false);
      });
      return () => socket.disconnect();
    }
    loadProductReason();    
  },[store_id]);

  return (
    <React.Fragment>
      <Grid container spacing={3}  justifyContent={"center"} direction="row">
        <Grid item xs={12} md={2} lg={1}>
          <Tooltip title="Produtos não convertidos, nesta loja, hoje!">
            <IconButton aria-label="Selecionar" size="large">
              <InfoIcon />
            </IconButton>
          </Tooltip>
        </Grid>
        <Grid item xs={12} md={10} lg={11}>
          <Title> <HelpOutlineIcon /> Produtos não convertidos</Title>
        </Grid>
      </Grid>
      {isLoading?
        <div style={{paddingTop:'10px'}}>
            <CircularProgress />
        </div>
      :
        <ResponsiveContainer>
            <PieChart >
                <Pie data={ProductReason} dataKey="value"  outerRadius={80} fill="#8884d8" >
                    {
                        ProductReason.map((entry, index) =>{
                        return(<Cell key={`cell-${index}`} />)})
                    }
                </Pie>
                <Legend wrapperStyle={{}}/>
                <TooltipRecharts isAnimationActive={true}/>
            </PieChart>
        </ResponsiveContainer>
       }
    </React.Fragment>
  );
}